/**
 * @description: 解决js取小数位数时,精度问题方法
 * @param {number} data 数值
 * @param {number} setKeep 保留几位小数
 * @return {*}四舍五入后的数值
 */
export function roundTo(data, setKeep) {
  let result = data + 1 * Math.pow(10, -(setKeep + 3));
  const factor = Math.pow(10, setKeep);
  return Math.round(result * factor) / factor;
}
